module.exports = __webpack_public_path__ + "static/img/far2_active.e63ce064.jpg";